import React from 'react';
import PropTypes from 'prop-types';
import useSessionsRoutes from 'common/components/TouchpointEditor/hooks/useSessionsRoutes';
import { ButtonWithPreview } from 'common/components/TouchpointEditor/components/TouchpointNodes/Button';

export default function LeaveSessionButton(props) {
    const sessionsRoutes = useSessionsRoutes();

    return <ButtonWithPreview {...props} to={sessionsRoutes.leaveSessionUrl} dataQa="session_leave_button" />;
}

LeaveSessionButton.propTypes = {
    meta: PropTypes.shape({
        content: PropTypes.string,
    }).isRequired,
};

LeaveSessionButton.splash = {
    ...ButtonWithPreview.splash,
    defaultProps: {
        ...ButtonWithPreview.splash.defaultProps,
        meta: {
            ...ButtonWithPreview.splash.defaultProps.meta,
            content: 'Leave Session',
        },
    },
};
